import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import withRouter from "../../HOC/withRouter";
import { userActions } from "../../store/user/actions";
import { promisify } from "../../utils/promisify";
import { getPrimaryAction, getTimeAgo, getInfoIconImage } from "../../utils/notification";
import { compose } from "react-recompose";
import NotificationLogo from "./NotificationLogo";
import NotificationText from "./NotificationText";
import "./styles.scss";
import { makeOppositeShade } from "../../utils/colorService";

const FeedsList = ({ notifications, t, navigate, setUnreadStatus, client, onClick, columns }) => {
  const viewProfile = user => {
    navigate(`/view-profile/${user._id}`);
  };

  const viewTouchPoint = (touchPointId, commentId) => {
    if (commentId) {
      navigate({
        pathname: `/touchpoint/${touchPointId}`,
        state: { commentId: commentId },
      });
    } else {
      navigate(`/touchpoint/${touchPointId}`);
    }
  };

  const viewPage = pageUrl => {
    navigate(`/${pageUrl}`);
  };

  const setReviewed = (notification, state) => {
    if (notification.isReviewed !== state) {
      promisify(setUnreadStatus, { notificationId: notification._id, isReviewed: state });
    }
  };

  const markAsRead = (e, notification) => {
    e.stopPropagation();
    setReviewed(notification, !notification.isReviewed);
  };

  const handlePrimaryAction = (notification, viewProfile, viewTouchPoint, viewPage) => {
    let viewDetails = getPrimaryAction(notification, viewProfile, viewTouchPoint, viewPage);
    setReviewed(notification, true);
    viewDetails();
    onClick();
  };

  return (
    <div className="notifications-modal">
      {!!notifications?.length &&
        notifications?.map((notification, index) => (
          <div
            key={index}
            onClick={() => handlePrimaryAction(notification, viewProfile, viewTouchPoint, viewPage)}
            className={notification.isSeen ? "notification-item" : "notification-item new"}
          >
            <div
              onClick={e => markAsRead(e, notification)}
              className={notification.isReviewed ? "read-status-point" : "read-status-point new"}
            />
            <div className="position-relative">
              <NotificationLogo notification={notification} viewProfile={viewProfile} setReviewed={setReviewed} />
              <span className="info-icon">
                {getInfoIconImage(notification, client.primaryColor, makeOppositeShade(client.secondaryTextColor))}
              </span>
            </div>
            <div>
              <NotificationText
                notification={notification}
                viewProfile={viewProfile}
                viewTouchPoint={viewTouchPoint}
                viewPage={viewPage}
                setReviewed={setReviewed}
                t={t}
                onClick={onClick}
                columns={columns}
                client={client}
              />
              <div className="notification-time-ago">{getTimeAgo(notification, t)}</div>
            </div>
          </div>
        ))}
    </div>
  );
};

const mapStateToProps = state => ({
  notifications: state.user.notifications,
  client: state.client.client,
  columns: state.orga.columns,
});

export default compose(withRouter, connect(mapStateToProps, userActions))(withTranslation()(FeedsList));
